import { analyticsClick } from "../../helpers/analytics";
import { useThirdPartyScriptMikmak } from "../../helpers/useThirdPartyScriptMikmak";
import { ButtonPcs } from "../ButtonPcs/ButtonPcs";
import { CosmosButtonProps } from "@cosmos/web-react";
import { ComponentProps } from "react";

export const BuyNowMikmak = ({
  mikmakIds,
  label,
  className,
  buttonSize = "medium",
  buttonCustomColor,
  analyticsElementPosition,
}: {
  mikmakIds: (string | null)[] | null;
  label: string;
  className: string;
  buttonSize: CosmosButtonProps["size"];
  buttonCustomColor?: ComponentProps<typeof ButtonPcs>["customColor"];
  analyticsElementPosition?: string;
}) => {
  const ThirdPartyScriptMikmak = useThirdPartyScriptMikmak();

  return (
    <>
      {ThirdPartyScriptMikmak}
      <ButtonPcs
        data-mm-wtbid="66d0c1b09ce37048eeaa27a4"
        data-mm-ids={mikmakIds?.join(",")}
        size={buttonSize}
        className={className}
        customColor={buttonCustomColor ?? undefined}
        onClick={() => {
          analyticsClick({
            value: "Buy now",
            clickUrl: "???",
            elementPosition: analyticsElementPosition || null,
            method: "Outbound: FALSE",
            contentType: "CTA",
          });
        }}
      >
        {label ?? ""}
      </ButtonPcs>
    </>
  );
};
